var exports = {
  "w": "Box_1__4yTbfu",
};

module.exports = exports;
